/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpgradeAttemptRequest = {
    /**
     * Array of inventory item IDs to use for upgrade
     */
    inventoryItemIds: Array<string>;
    /**
     * ID of the item to upgrade to (multiplier is calculated from target item price / input items value)
     */
    targetItemId: string;
    /**
     * Price range type: HIGH or LOW
     */
    rangeType: UpgradeAttemptRequest.rangeType;
    /**
     * Optional start percentage for the win window (0-100)
     */
    rangeStartPercent?: number;
};
export namespace UpgradeAttemptRequest {
    /**
     * Price range type: HIGH or LOW
     */
    export enum rangeType {
        HIGH = 'HIGH',
        LOW = 'LOW',
    }
}

